module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17f3phN/tc-custom/9781626813328.jpg?1702083786038",
      "alt": "This image is the cover for the book Sweet Forever"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sweet Forever\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Pirates, time travel, forever love . . . “[Weyrich] has taken several threads and woven them into a fabric of startling beauty and magic” ("), _c('i', [_vm._v("Romantic Times")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Julianna Doran experiences her first heated spark of desire in a haunted Hudson River mansion. Though she knows the days of pirate ships are over, she cannot stop yearning for the enticingly handsome and boldly dangerous Brom Vanderzee, the ghostly sea captain she gets but a mere glimpse of while playing with a Ouija board."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Years later, even as Julianna prepares to wed, she still dreams of the achingly forbidden specter of her past. Seizing her last chance to understand her longing heart, she returns to the place she first saw Brom and is granted an exquisite night of passion with him before he disappears again."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Determined not to lose him again, she crosses the boundaries of her world to join him in his, and solidify their love—this time for good.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Becky Lee Weyrich\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Diversion Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0